import React, { useContext } from 'react';
import {
    Dropdown, DropdownButton, Navbar, Nav, NavItem, NavLink,
    Badge, NavDropdown, Form, FormControl, Button
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faList, faLock, faUser, faWrench, faCog, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'

import { NavBreadcrumb } from '../../controls';
import defaultUserAvatar from '../../assets/img/defaultUserAvatar.png'
import { AuthContext } from '../../contexts/AuthContext';

const MainHeader = (props) => {

    const authContext = useContext(AuthContext);
    
    return (
        <>
            <Navbar expand="lg" className="bg-light">
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        {
                            authContext.currentUser?.nav?.map((navitem, idx) => {
                                return (
                                    navitem.show === true ?
                                        <li className="nav-item" key={idx}>
                                            <LinkContainer to={navitem.url}>
                                                <a className="nav-link">
                                                    {navitem.name}
                                                </a>
                                            </LinkContainer>
                                        </li> : null
                                )
                            })
                        }
                    </Nav>
                    <Nav className="ml-auto" navbar>
                        <Dropdown>
                            <Dropdown.Toggle as="span" className="noCaret givemethefinger">
                                <img src={defaultUserAvatar} className="img-avatar" alt="admin@test.com" />
                                {authContext.currentUser?.fullName}
                            </Dropdown.Toggle>
                            <Dropdown.Menu right className="avatar-dropdown-menu">
                                {/* 
                                    <Dropdown.Item>
                                        <LinkContainer to={'/user'}>
                                            <a>
                                                <FontAwesomeIcon icon={faUser} /> User Profile
                                        </a>
                                        </LinkContainer>
                                    </Dropdown.Item>
                                    <Dropdown.Item>
                                        <LinkContainer to={'/user/settings'}>
                                            <a>
                                                <FontAwesomeIcon icon={faCog} /> User Settings
                                        </a>
                                        </LinkContainer>
                                    </Dropdown.Item>

                                    */}
                                <Dropdown.Item>
                                    <LinkContainer to={'/user/password'}>
                                        <a>
                                            <FontAwesomeIcon icon={faLock} /> Change Password
                                        </a>
                                    </LinkContainer>
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item>
                                    <a onClick={() => authContext.logOut()}>
                                        <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                                        </a>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <NavBreadcrumb routes={authContext.currentUser?.routes} />
        </>
    )
}
export default MainHeader